import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addCheckInScheduleApi,
  addCheckInScheduleFeedbackApi,
  addPerformanceEvaluationApi,
  addPerformanceEvaluationFeedbackApi,
  getAttendanceAverageApi,
  getAveargeJobRatingListApi,
  getCheckInScheduleListApi,
  getManagersAvailableCheckInScheduleSlotsDetailsApi,
  getMySpaceAnniversaryAndUpcomingBirthdayApi,
  getMySpacePeopleOnLeaveApi,
  getMyTeamMembersApi,
  getPerformanceEvaluationListApi,
  getSingleCheckInScheduleDetailsApi,
  getSinglePerformanceEvaluationDetailsApi,
  updateCheckInScheduleApi,
} from "../../apis/mySpaceApis";
import {
  AddCheckInScheduleFeedbackPayloadType,
  AddFeedbackPerformanceEvaluationPayloadType,
  AddPerformanceEvaluationPayloadType,
  GetAttendanceAveragePayloadType,
  GetAverageJobRatingPayloadType,
  GetCheckInScheduleListPayloadType,
  GetManagersCheckInScheduleSlotsPayloadType,
  GetMySpacePeopleOnLeavePayloadType,
  GetMySpaceUpcomingEventsDataPayloadType,
  GetMySpaceViewTeamMembersPayloadType,
  GetPerformanceEvaluationPayloadType,
  GetSingleCheckInScheduleDetailsPayloadType,
  GetSinglePerformanceEvaluationPayloadType,
  UpdateCheckInSchedulePayloadType,
} from "../../commonTypes/mySpaceType";

export const getMySpaceWorkAnniversaryAction = createAsyncThunk(
  "mySpaceWorkAnniversary/get",
  async (data: GetMySpaceUpcomingEventsDataPayloadType) => {
    const response = await getMySpaceAnniversaryAndUpcomingBirthdayApi(data);
    return response.data;
  }
);

export const getMySpaceUpcomingBirthDayAction = createAsyncThunk(
  "mySpaceUpcomingBirthDay/get",
  async (data: GetMySpaceUpcomingEventsDataPayloadType) => {
    const response = await getMySpaceAnniversaryAndUpcomingBirthdayApi(data);
    return response.data;
  }
);

export const getPeopleOnLeaveAction = createAsyncThunk(
  "mySpacePeopleOnLeave/get",
  async (data: GetMySpacePeopleOnLeavePayloadType) => {
    const response = await getMySpacePeopleOnLeaveApi(data);
    return response.data;
  }
);

export const getAttendanceAverageAction = createAsyncThunk(
  "attendanceAverage/get",
  async (data: GetAttendanceAveragePayloadType) => {
    const response = await getAttendanceAverageApi(data);
    return response.data;
  }
);

export const addCheckInScheduleAction = createAsyncThunk(
  "checkInSchedule/add",
  async (data: UpdateCheckInSchedulePayloadType) => {
    const response = await addCheckInScheduleApi(data);
    return response.data;
  }
);

export const updateCheckInScheduleAction = createAsyncThunk(
  "checkInSchedule/update",
  async (data: UpdateCheckInSchedulePayloadType) => {
    const response = await updateCheckInScheduleApi(data);
    return response.data;
  }
);

export const getCheckInScheduleListAction = createAsyncThunk(
  "checkInSchedule/list",
  async (data: GetCheckInScheduleListPayloadType) => {
    const response = await getCheckInScheduleListApi(data);
    return response.data;
  }
);

export const getCheckInScheduleManagerViewListAction = createAsyncThunk(
  "checkInSchedule/managerViewList",
  async (data: GetCheckInScheduleListPayloadType) => {
    const response = await getCheckInScheduleListApi(data);
    return response.data;
  }
);

export const getManagersAvailableCheckInScheduleSlotsDetailsAction =
  createAsyncThunk(
    "checkInSchedule/managersAvailableCheckInSlots",
    async (data: GetManagersCheckInScheduleSlotsPayloadType) => {
      const response = await getManagersAvailableCheckInScheduleSlotsDetailsApi(
        data
      );
      return response.data;
    }
  );

export const getSingleCheckInScheduleDetailsAction = createAsyncThunk(
  "checkInSchedule/single",
  async (data: GetSingleCheckInScheduleDetailsPayloadType) => {
    const response = await getSingleCheckInScheduleDetailsApi(data);
    return response.data;
  }
);

export const addCheckInScheduleFeedbackApiAction = createAsyncThunk(
  "checkInScheduleFeedback/add",
  async (data: AddCheckInScheduleFeedbackPayloadType) => {
    const response = await addCheckInScheduleFeedbackApi(data);
    return response.data;
  }
);

// pe form
export const getPerformanceEvaluationListAction = createAsyncThunk(
  "performanceEvaluation/list",
  async (data: GetPerformanceEvaluationPayloadType) => {
    const response = await getPerformanceEvaluationListApi(data);
    return response.data;
  }
);

export const addPerformanceEvaluationAction = createAsyncThunk(
  "performanceEvaluation/add",
  async (data: AddPerformanceEvaluationPayloadType) => {
    const response = await addPerformanceEvaluationApi(data);
    return response.data;
  }
);

export const getSinglePerformanceEvaluationDetailsAction = createAsyncThunk(
  "performanceEvaluation/single",
  async (data: GetSinglePerformanceEvaluationPayloadType) => {
    const response = await getSinglePerformanceEvaluationDetailsApi(data);
    return response.data;
  }
);

export const addPerformanceEvaluationFeedbackAction = createAsyncThunk(
  "performanceEvaluationFeedback/add",
  async (data: AddFeedbackPerformanceEvaluationPayloadType) => {
    const response = await addPerformanceEvaluationFeedbackApi(data);
    return response.data;
  }
);

// job average rating
export const getAverageJobRatingListAction = createAsyncThunk(
  "averageJobRating/list",
  async (data: GetAverageJobRatingPayloadType) => {
    const response = await getAveargeJobRatingListApi(data);
    return response.data;
  }
);
// view my team members
export const getMyTeamMembersAction = createAsyncThunk(
  "mySpaceMyTeamMembers/get",
  async (data: GetMySpaceViewTeamMembersPayloadType) => {
    const response = await getMyTeamMembersApi(data);
    return response.data;
  }
);